
var map, newMarkers;

function loadMap() {
    var map;
	var mapCenter     = new google.maps.LatLng(center.lat, center.lng);
	var isTouchDevice = 'ontouchstart' in document.documentElement;
	var scrollwheel   = $('body').width() < 768 ? false : true;
	
	var mapOptions    = {
		zoom: 7,
		center: mapCenter,
		disableDefaultUI: false,
		navigationControl: true,
		scrollwheel: scrollwheel,
		draggable: true,
		panControl: false,
		navigationControlOptions: {style: 'SMALL', position: 'TOP_RIGHT'},
		mapTypeId: 'ROADMAP',
		minZoom : 7,
		maxZoom : 19,
		mapTypeControl: false,
		streetViewControl: false
	};
	
	var mapStyle = [
		{ "stylers": [ { "saturation": -100 } ] },{ "featureType": "water", "stylers": [ { "visibility": "simplified" }, { "saturation": -100 }, { "lightness": -28 } ] },
		{ "featureType": "administrative.country", "elementType": "geometry.stroke", "stylers": [ { "visibility": "on" }, { "lightness": -42 } ] },{ }
	];
	
	function initMap() {
		map = new google.maps.Map(document.getElementById("map"), mapOptions);
	
		var styledMapOptions = {map: map, name: 'mapStyle'};
		var sMapType = new google.maps.StyledMapType(mapStyle, styledMapOptions);
	
		map.mapTypes.set('mapStyle', sMapType);
		map.setMapTypeId('mapStyle');
	
		if (useGeolocation && navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function(position) {
				mapCenter = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
				map.setCenter(mapCenter);
				map.setZoom(12);
			});
		}

        var script = document.createElement('script');
        script.onload = function() {
            newMarkers = initMarkers(map, markers);
            var markerCluster = new MarkerClusterer(map, newMarkers, {
                gridSize: 30,
                maxZoom: 18,
                styles: [{
                    textColor: 'white',
                    url: assetsPath + '/img/marker-group2.svg',
                    height: 52,
                    width: 53
                }]
            });
        };
        script.src = assetsPath + '/js/plugins/infobox.js';
        document.body.appendChild(script);
	}
	
	$('.toggle-fullscreen').show().on('click', function(e) {
		e.preventDefault();
	
		if (!$(this).hasClass('active')) {
			$('#map-wrapper').addClass('fullscreen');
			$(this).addClass('active');
	
			var touchOptions = {
				draggable: true
			}
		} else {
			$('#map-wrapper').removeClass('fullscreen');
			$(this).removeClass('active');
	
			var touchOptions = {
				draggable: false
			}
		}
	
		var currentCenter = map.getCenter();
		google.maps.event.trigger(map, 'resize');
		map.setCenter(currentCenter);
	
		if (isTouchDevice) {
			map.setOptions(touchOptions);
		}
	});

	// google.maps.event.addDomListener(window, 'load', function() {
        initMap();
    // });
	google.maps.event.addDomListener(window, 'resize', function() {
		var currentCenter = map.getCenter();
	
		setTimeout(function() {
			map.setCenter(currentCenter);
		}, 100);
	});
	
	$('#locator-locations a').each(function(i){
		$(this).on('click', function(e){
			e.preventDefault();
			// map.setZoom(12);
	
			google.maps.event.trigger(newMarkers[i], 'click');
			map.setZoom(12);
	
			if ($('#mobilechecker').is(":visible")) {
				var offset = $('#locator-locations').offset();
				var posY = offset.top-520; // hoogte van map div (=480px) en offset list (=30px) + 10 voor het zicht
	
				$("body, html").animate({
				  scrollTop: posY
				}, 600);
	
			} else {
				return false;
			}
		});
	});
	
	function initMarkers(theMap, markerData) {
		//var image = new google.maps.MarkerImage(assetsPath + '/img/marker-pin.svg');

		var icon = {
			url: assetsPath + '/img/marker-pin2.svg', // url
			scaledSize: new google.maps.Size(40, 40) // scaled size
		};
	
	
		var newMarkers = [],
			marker;
	
		for (var i=0; i < markerData.length; i++) {
			marker = new google.maps.Marker({
				map: theMap,
				//icon: image,
				icon: icon,
				draggable: false,
				optimized: false,//IE11
				position: new google.maps.LatLng(markerData[i].latLng[0], markerData[i].latLng[1]),
				visible: true
			})
	
			newMarkers.push(marker);
	
			var template = $('.marker-template').clone();
			var templateHTML = template[0].outerHTML;
			templateHTML = templateHTML.replace("[count]", i);
			for (key in markerData[i]) {
				var search = "["+key+"]";
				while (templateHTML.indexOf(search) != -1) {
					templateHTML = templateHTML.replace(search, markerData[i][key]);
				}
			}
	
			//define the options for all infoboxes
			var myOptions = {
				alignBottom: true,
				content: templateHTML,
				disableAutoPan: false,
				maxWidth: 0,
				pixelOffset: new google.maps.Size(-35, 13),
				zIndex: null,
				infoBoxClearance: new google.maps.Size(1, 1),
				isHidden: false,
				enableEventPropagation: false
			};
	
			newMarkers[i].latitude = markerData[i].latLng[0];
			newMarkers[i].longitude = markerData[i].latLng[1];
			newMarkers[i].infobox = new InfoBox(myOptions);
	
			google.maps.event.addListener(marker, 'click', (function(marker, i) {
				return function() {
					for (var j in newMarkers) {
						if (j == i) continue;
						newMarkers[j].infobox.close();
					}
	
					newMarkers[i].infobox.open(theMap, this);
	
					// setTimeout(function() {
						mapCenter = new google.maps.LatLng(newMarkers[i].latitude, newMarkers[i].longitude);
						map.setCenter(mapCenter);
					// }, 500);
				}
			})(marker, i));
		}
	
		return newMarkers;
	}
}
